import InsuranceProvidersSelect from './insurance-providers-select';

export default InsuranceProvidersSelect;
